import { observer, use$ } from '@legendapp/state/react';
import { Card } from '@mantine/core';
import { PATTERN_MAP } from '../../../constants';
import { autoBetState$, gameState$, towersState$ } from '../../../state';
import { BrickIcon } from '../BrickIcon';
import styles from './AutoBetTowersGridBrick.module.css';

export type AutoBetTowersGridBrickProps = {
  row: number;
  column: number;
};

export const AutoBetTowersGridBrick = observer(
  ({ row, column }: AutoBetTowersGridBrickProps) => {
    const bricks = use$(towersState$.bricks);

    const { pickedBricks, isBetting, handlePickedBrick } = use$(() => ({
      pickedBricks: autoBetState$.pickedBricks.get(),
      isBetting: autoBetState$.isAutoBetting.get(),
      handlePickedBrick: autoBetState$.handlePickedBrick,
    }));

    const pattern = gameState$.pattern.get();

    const { rows, cols } = PATTERN_MAP[pattern];

    const brick = bricks[row]?.[column];

    const isPicked = pickedBricks[row] === column;

    const isClickable = row <= pickedBricks.length;

    return (
      <Card
        className={styles.brick}
        data-betting={isBetting}
        data-brick={brick?.type === 'BRICK'}
        data-clickable={isClickable}
        data-column={column}
        data-mine={brick?.type === 'MINE'}
        data-picked={isPicked}
        data-row={row}
        data-test-id="auto-bet-brick"
        data-unknown={brick?.type === 'UNKNOWN'}
        onClick={() => handlePickedBrick({ row, column })}
        p={0}
        style={{
          aspectRatio: rows / cols,
        }}
        withBorder
      >
        {brick ? (
          <BrickIcon data-test-id="auto-bet-brick-icon" type={brick.type} />
        ) : null}
      </Card>
    );
  }
);
